import './MobileNotification.css';

function MobileNotification() {
  return (
    <div className="mobileNotification">
      <h2 className="mobileNotification__title">Упс!)</h2>
      <p className="mobileNotification__text">Я не помещаюсь в ширину вашего экрана...( </p>
      <p className="mobileNotification__text">Откройте меня на компьютере, пожалуйста!)</p>
    </div>
  );
}

export default MobileNotification;
